<template>
  <!-- 发起审批、流程配置公用 -->
  <div class="aprove-setting">
    <div class="items mb-20" v-for="item in list" :key="item.id">
      <h1>
        {{item.name}}
        <svg-icon
          v-if="item.star"
          icon-class="star"
          class-name="ml-5"
          style="font-size:18px;position: relative;top:1px;"
        />
      </h1>
      <div class="item-box">
        <el-row :gutter="20">
          <el-col :xs="4" :sm="4" :md="4" :lg="3" :xl="3" v-for="it in item.data" :key="it.id">
            <el-card class="item tc" @click.native="handleClick(it.id)">
              <img :src="it.image" alt>
              <!-- <svg-icon icon-class="approve-qingjia" class-name="icon"/> -->
              <h4 class="mt-10">{{it.name}}</h4>
            </el-card>
          </el-col>

          <!-- <el-col :span="4">
            <el-card class="item tc">
              <svg-icon icon-class="approve-chuchai" class-name="icon"/>
              <h4>出差申请</h4>
            </el-card>
          </el-col>-->
        </el-row>
      </div>
    </div>

    <dialogProcessSetting ref="dialogProcessSetting" @refresh="getDataList"></dialogProcessSetting>
    <dialog-leave-apply ref="dialogLeaveApply"></dialog-leave-apply>
  </div>
</template>

<script>
import dialogProcessSetting from './dialog/dialog-process-setting' // 流程设置
import dialogLeaveApply from './dialog/leave-apply' // 请假申请
export default {
  components: {
    dialogProcessSetting,
    dialogLeaveApply
  },
  watch: {
    $route(path) {
      this.pageType = path.query.pageType
      this.getDataList()
    }
  },
  data() {
    return {
      pageType: this.$route.query.pageType, // '':发起审批  setting:流程配置
      list: []
    }
  },
  methods: {
    getDataList() {
      this.$http
        .get('/workflowConfig/list', {
          type: this.pageType === 'setting' ? '' : 'hot'
        })
        .then(res => {
          if (res.success) {
            this.list = res.result
            if(this.$route.query.typeId){
              this.handleClick(this.$route.query.typeId)
            }
          } else {
            this.$message.error(res.message)
          }
        })
    },
    handleClick(id) {
      if (this.pageType === 'setting') {
        this.$refs.dialogProcessSetting.init(id)
      } else {
        this.$refs.dialogLeaveApply.init(id)
      }
    }
  },
  created() {
    this.getDataList()
  }
}
</script>

<style lang="scss" scoped>
.aprove-setting {
  padding-bottom: 100px;
  margin: 0 auto;
  box-sizing: border-box;
  .item-box {
    // display: flex;
    .item {
      // width: 200px;
      margin-bottom: 20px;
      height: 100px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      img {
        max-height: 30px;
      }
    }
  }
  .icon {
    font-size: 36px;
  }
}
</style>


